(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const isSlipraMetaAndroidIab = document.documentElement.classList.contains('slipra-meta-android-iab');
  const url = new URL(window.location.href);
  if (!isSlipraMetaAndroidIab && url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["slipra-collection-intro"] && !Shopify.designMode) return;
  try {
    
  (() => {
  if (document.documentElement.classList.contains('slipra-meta-android-iab')) return;

  class SlipraCollectionTabs {
    constructor(section) {
      this.section = section;
      this.tabs = Array.from(section.querySelectorAll('[data-slipra-products-tab]'));
      this.emptyState = null;

      this.tabs.forEach((tab) => {
        tab.addEventListener('click', (event) => this.onTabClick(event, tab));
      });

      const activeTab = this.tabs.find((tab) => tab.getAttribute('aria-selected') === 'true');
      const fallbackTab = this.tabs.find((tab) => tab.dataset.slipraProductsTab === 'black') || this.tabs[0];
      this.setActiveTab(activeTab || fallbackTab);
      this.filterProducts((activeTab || fallbackTab)?.dataset.slipraProductsTab);
    }

    onTabClick(event, tab) {
      this.setActiveTab(tab);
      this.filterProducts(tab.dataset.slipraProductsTab);
    }

    setActiveTab(activeTab) {
      this.tabs.forEach((tab) => {
        const isActive = tab === activeTab;
        const inputId = tab.getAttribute('for');
        const input = inputId ? document.getElementById(inputId) : null;

        if (input) {
          input.checked = isActive;
        }

        tab.classList.toggle('is-active', isActive);
        tab.setAttribute('aria-selected', String(isActive));

        if (isActive) {
          tab.setAttribute('aria-current', 'page');
        } else {
          tab.removeAttribute('aria-current');
        }
      });
    }

    filterProducts(color) {
      const grid = document.querySelector('.product-grid');
      if (!grid || !color) return;

      const cards = Array.from(grid.querySelectorAll('.product-grid__item'));
      // Only cards tagged by main-collection.liquid participate in real filtering.
      // Untagged cards stay visible so the page still works while store data is being cleaned up.
      const taggedCards = cards.filter((card) => ['black', 'white', 'both'].includes(card.dataset.slipraProductColor));
      const shouldFilter = taggedCards.length > 0;
      let visibleCount = 0;

      cards.forEach((card) => {
        const cardColor = card.dataset.slipraProductColor;
        const isVisible = !shouldFilter || cardColor === color || cardColor === 'both';
        card.hidden = !isVisible;
        if (isVisible) visibleCount += 1;
      });

      this.toggleEmptyState(grid, shouldFilter && visibleCount === 0, color);
      this.updateStatus(color, visibleCount);
    }

    toggleEmptyState(grid, show, color) {
      if (!this.emptyState) {
        this.emptyState = document.createElement('li');
        this.emptyState.className = 'slipra-products-empty';
        this.emptyState.setAttribute('aria-live', 'polite');
        grid.appendChild(this.emptyState);
      }

      this.emptyState.textContent = `No ${color} products are assigned yet.`;
      this.emptyState.classList.toggle('is-visible', show);
    }

    updateStatus(color, visibleCount) {
      const status = this.section.querySelector('[data-slipra-products-status]');
      if (!status) return;

      const label = color === 'white' ? 'White collection' : 'Black collection';
      status.textContent = label;
    }
  }

  document.querySelectorAll('.slipra-collection-intro').forEach((section) => {
    new SlipraCollectionTabs(section);
  });
  })();

  } catch(e) { console.error(e); }
})();
})();
